"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = colorLabel;

var _globals = require("../../../globals.js");

function colorLabel(_ref) {
  var theme = _ref.theme,
      states = _ref.states,
      focus = _ref.focus,
      error = _ref.error;

  if (error) {
    return focus ? theme.color : states[_globals.STATE.IDLE].color;
  } else {
    return theme.color;
  }
}